import React, { Component } from "react";
import { connect } from "react-redux";
import classes from "./MobileSign.css";
import global from "../../global.css";
import ValidationCenter from "../../ValidationCenter/ValidationCenter";
import { alertMessenger, RequestForRefundList } from "../../store/action/index";

class MobileSign extends Component {
  state = {
    PhoneNumber: {
      value: "",
      validation: false,
      touch: false,
      message: null
    },
    Loader: false
  };

  InputHandler = event => {
    event.persist();
    this.setState(prevState => {
      return {
        PhoneNumber: {
          ...prevState.PhoneNumber,
          value: event.target.value,
          touch: true,
          message: null
        }
      };
    });
  };

  Validation = props => {
    let PayBackValid = ValidationCenter(props);
    if (!PayBackValid.valid) {
      if (PayBackValid.Message) {
        this.setState(prevState => {
          return {
            [props.FieldName]: {
              ...prevState[props.FieldName],
              validation: false,
              message: PayBackValid.Message
            }
          };
        });
      }
    } else {
      this.setState(prevState => {
        return {
          [props.FieldName]: {
            ...prevState[props.FieldName],
            validation: true
          }
        };
      });
    }
  };

  StorePhoneNumber = event => {
    event.preventDefault()
    event.persist()
    this.Validation({
      number: {
        type: "NUM",
        minlength: 11,
        maxLength: 11,
        value: this.state.PhoneNumber.value
      },
      FieldName: "PhoneNumber"
    })
    this.setState(
      {
        Loader: true
      },
      () => {
        if (this.state.PhoneNumber.validation) {
          localStorage["CELL_PHONE"] = this.state.PhoneNumber.value;
          localStorage["LOG_IN_WITH_PHONE"] = "true";
          setTimeout(() => {
            this.props.alertMessenger("شماره شما با موفقیت ثبت شد");
            this.setState({
              Loader: false
            });
            this.props.loginStatus();
            this.props.Autoclose();
            this.props.RequestForRefundList();
          }, 1000);
        } else {
          this.props.alertMessenger("شماره شما نامعتبر است");
          this.setState({
            Loader: false
          });
        }
      }
    );
  };

  render() {
    return (
      <div className={classes.localFather}>
        <h3>ورود با شماره تلفن</h3>
        <form onSubmit={this.StorePhoneNumber}>
          <div className={global.inputFather}>
            <input
              type="text"
              dir="ltr"
              placeholder=" Exp :09120000000"
              className={
                this.state.PhoneNumber.message ? global.ErrorField : null
              }
              onChange={this.InputHandler}
              maxLength={11}
              value={this.state.PhoneNumber.value}
              onBlur={() =>
                this.Validation({
                  number: {
                    type: "NUM",
                    minlength: 11,
                    maxLength: 11,
                    value: this.state.PhoneNumber.value
                  },
                  FieldName: "PhoneNumber"
                })
              }
            />
            {this.state.PhoneNumber.message ? (
              <span className={global.Error}>
                {this.state.PhoneNumber.message}
              </span>
            ) : null}
            <label
              className={[
                this.state.PhoneNumber.touch ? global.LabelMove : null,
                this.state.PhoneNumber.message ? global.ErrorLabel : null
              ].join(" ")}
            >
              تلفن همراه
            </label>
          </div>
          <div className={classes.confirmFather}>
            <input
              type="submit"
              className={[
                classes.conform,
                this.state.Loader ? global.Load : null
              ].join(" ")}
              value="تایید"
            />
            <span
              className={this.state.Loader ? global.Loader : null}
            />
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    alertMessenger: SMS => dispatch(alertMessenger(SMS)),
    RequestForRefundList: () => dispatch(RequestForRefundList())
  };
};

export default connect(
  null,
  mapDispatchToProps
)(MobileSign);
